import { trackingService } from '../../tracking';
import { TrackerType } from '../enums';
import { PRODUCT_NAME, PARTNER_ID } from './constants';

export const trackEmailSentView = (): void => {
  trackingService.trackEvent(
    'EMAIL_SENT',
    PRODUCT_NAME,
    {
      page: 'e-mail enviado',
      route: '/email-enviado',
      placement: '',
      surface: '',
      flow: 'cadastro usuário',
      step: 'e-mail enviado',
      element: '',
      action: 'view',
      user_id: '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackEmailSentHelpClick = (): void => {
  trackingService.trackEvent(
    'HELP',
    PRODUCT_NAME,
    {
      page: 'e-mail enviado',
      route: '',
      placement: 'main',
      surface: '',
      flow: 'cadastro usuário',
      step: 'e-mail enviado',
      element: 'link',
      action: 'click',
      user_id: '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackEmailSentBackClick = (): void => {
  trackingService.trackEvent(
    'BACK',
    PRODUCT_NAME,
    {
      page: 'e-mail enviado',
      route: '',
      placement: 'main',
      surface: '',
      flow: 'cadastro usuário',
      step: 'e-mail enviado',
      element: 'button',
      action: 'click',
      user_id: '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};
